import React from "react";
import DotLegalPaper from "@common/components/dotLegalPaper/DotLegalPaper";
import TopBarDivider from "./TopBarDivider";

export interface IEntityDetailTopBarProps {
    children: React.ReactNode;
}

function EntityDetailTopBar(props: IEntityDetailTopBarProps) {
    const rows = React.Children.toArray(props.children).filter(Boolean);
    return (
        <DotLegalPaper>
            {rows.map((row, index) => (
                <React.Fragment key={index}>
                    {index > 0 && <TopBarDivider />}
                    {row}
                </React.Fragment>
            ))}
        </DotLegalPaper>
    );
}

export default EntityDetailTopBar;
